import { ModalBody } from '@fiverr-private/overlay';

export default ModalBody;
